import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'fmDate',
})
export class FmDatePipe implements PipeTransform {
  constructor() {}
  transform(value: string, args?: string): string | null {
    if (!value) {
      return '-';
    }
    return new DatePipe('en-US').transform(value, args || 'yyyy-MM-dd HH:mm:ss');
  }
}
